import ContactUsForm from "@components/BasicComponents/Forms/ContactUsForm/ContactUsForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Overlay from "@components/CustomTypography/Overlay/Overlay"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import {AdvancedSideAssetModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import SocialData from "@jsons/socialResponsibility.json"
import React from "react"

import styles from "./SocialResponsibilityContactFormSection.module.scss"

const SocialResponsibilityContactFormSection = (props?: {
	data?: AdvancedSideAssetModuleType
}) => {
	const pageData = getTranslatedPageData(SocialData, true, true)
	const AdvancedSideAsset = getValueOrThrow(pageData.AdvancedSideAsset)

	const data = AdvancedSideAsset[4]

	return (
		<section id={"book-a-demo"}>
			<Separator
				size={128}
				style={{
					color: "white",
					position: "relative",
					background:
						"url(/dreamBroker/footerBGSmall_2024-11-01-085050.jpg)",
					backgroundSize: "cover",
				}}
				type={"padding"}
			>
				<ContainerWrapper>
					<Separator
						className={styles.formContainer}
						type={"padding"}
						withoutMeasure
					>
						<Separator
							className={styles.formTextBox}
							type={"padding"}
							withoutMeasure
						>
							<Typography
								content={data.mainContent?.[0].title}
								size={Size.XXXL}
								variant={Variant.Title}
								contrast
							/>
							<Separator size={16} />
							<Typography
								content={data.mainContent?.[0].subtitle}
								variant={Variant.Paragraph}
								contrast
							/>
						</Separator>
						<Separator
							className={styles.formFormBox}
							type={"padding"}
							withoutMeasure
						>
							<Separator
								backgroundColor={"rgba(255,255,255,0.9)"}
								style={{borderRadius: "10px"}}
								withoutMeasure
							>
								<Separator customPadding={"25px"}>
									<ContactUsForm
										container={{
											style: {
												color: "black",
											},
										}}
									/>
								</Separator>
							</Separator>
						</Separator>
					</Separator>
				</ContainerWrapper>
				<Overlay opacity={"0.4"} />
			</Separator>
		</section>
	)
}

export default SocialResponsibilityContactFormSection
